import { createClient } from "@supabase/supabase-js";
import { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } from "./constants";

export const supabase = createClient(
    "https://cbxyvfnbcewlzwnangpc.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTY0MDQxNTM5NCwiZXhwIjoxOTU1OTkxMzk0fQ.JST7bg7OS-V7ipU0sCa034-hpXpio4oMMsde2HDhI7w"
);
